import { render, staticRenderFns } from "./BindingKeyInputBox.vue?vue&type=template&id=1850afad&"
import script from "./BindingKeyInputBox.vue?vue&type=script&lang=js&"
export * from "./BindingKeyInputBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports